// extracted by mini-css-extract-plugin
export default {"bgTrain":"HomePage_bgTrain__4XIJK","loginBtn":"HomePage_loginBtn__Kxt3I","modal":"HomePage_modal__88vcq","modalOverlay":"HomePage_modalOverlay__10-jh","hide":"HomePage_hide__+S8+c"};